<template>
  <custom-dialog v-drag-dialog :title="model.title" :visible="visible" v-on="$listeners" width="600px" class="maintain-item-dialog" :appendToBody="true">
    <div class="dialog-body">
      <!-- 表单 -->
      <el-form :model="form" :inline="true" ref="form" label-position="top" :rules="rules">
        <el-row>
          <!-- 产品型号原型是多选，但是后端不改 -->
          <el-col :span="24">
            <el-form-item :label="$t('asm_maintain_item_dialog.chan_pin_xing_hao')" prop="productCode">
              <custom-select url="productCodeSelectList" v-model="form.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="type === 'repair'">
            <el-form-item :label="$t('asm_maintain_item_dialog.shi_jian_dai_ma')" prop="eventCode">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-input disabled v-model="form.eventCode" placeholder=""></el-input>
                </el-col>
                <el-col :span="12">
                  <el-button @click="showSelectEvent">{{ $t('asm_maintain_item_dialog.xuan_ze_shi_jian') }}</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="type === 'maintain' ? $t('asm_maintain_item_dialog.bao_yang_xiang') : $t('asm_maintain_item_dialog.wei_xiu_xiang')" prop="itemName">
              <el-input :max="50" placeholder="" v-model="form.itemName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('asm_maintain_item_dialog.xian_shi_shun_xu')" prop="showOrder">
              <el-input-number v-model="form.showOrder" :min="0"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('asm_maintain_item_dialog.miao_shu')" prop="name">
              <el-input type="textarea" :rows="3" :max="200" placeholder="" v-model="form.itemDesc"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="type === 'maintain'">
            <el-form-item :label="$t('asm_maintain_item_dialog.tu_biao')">
              <t-upload :bizId="form.itemId" bizType="asm.service.item.icon" v-model="fileList" :tip="$t('asm_maintain_item_dialog.zcJPGPNGgsdgwj2Myn')" :limit="1" ref="maintainImage" :autoUpload="false"></t-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="type === 'maintain'">
            <el-form-item :label="$t('asm_maintain_item_dialog.bao_yang_shou_ce')">
              <t-upload
                type="file"
                :bizId="form.itemId"
                bizType="asm.service.item.atlas"
                v-model="textFileList"
                :tip="$t('asm_maintain_item_dialog.zcJPGPNGgsdgwj2Myn')"
                :limit="3"
                ref="maintainFile"
                :autoUpload="false"
              ></t-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="type === 'repair'">
            <el-form-item :label="$t('asm_maintain_item_dialog.jie_jue_fang_an')">
              <custom-editor v-model="form.serviceDisposal" :height="240" :readonly="true" menubar="" :toolbar="null"></custom-editor>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <select-event-dialog v-if="selectEventVisible" @close="selectEventVisible = false" @confirm="selectEventConfirm" :model="selectEventModel"></select-event-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';
import dialogMixins from '@/mixins/dialog_mixins';
import customEditor from '@/components/customEditor/index.vue';
import selectEventDialog from './select_event_dialog';

export default {
  mixins: [dialogMixins],
  components: { tUpload, selectEventDialog, customEditor },
  props: {
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: this.$t('asm_maintain_item_dialog.biao_ti'),
          data: {},
        };
      },
    },
    // maintain：保养  repair：维修
    type: {
      type: String,
      default: 'maintain',
    },
  },
  data() {
    return {
      item: {},
      deviceModelList: [],
      fileList: [],
      textFileList: [],
      form: {
        itemId: '',
        productCode: '',
        itemName: '',
        itemDesc: '',
        showOrder: '',
        serviceClass: '',
        eventCode: '',
        serviceDisposal: '',
      },
      selectEventVisible: false,
      selectEventModel: {},
      serviceClassMap: {},
    };
  },
  computed: {
    rules() {
      return {
        productCode: { required: true, message: this.$t('asm_maintain_item_dialog.qxzcpxh') },
        itemName: { required: true, message: this.$t('asm_maintain_item_dialog.qsrwxbyx') },
        showOrder: { required: true },
        itemDesc: [{ max: 200, message: this.$t('Common.com_rules_length_max', [200]), }],
      };
    },
  },
  mounted() {
    this.getServiceClassDic().then((map) => {
      this.serviceClassMap = map;
      this.initDialog();
    });
  },
  methods: {
    // serviceClass获取字典
    getServiceClassDic() {
      return new Promise((resolve) => {
        this.getDictionary('asm_basic_item_service_class', (res) => {
          const list = res.asm_basic_item_service_class;
          const map = {};
          list.forEach((item) => {
            map[item.code] = item.value;
          });
          resolve(map);
        });
      });
    },
    selectEventConfirm(list) {
      this.form.eventCode = list[0].eventCode;
      this.form.serviceDisposal = list[0].serviceDisposal;
    },
    showSelectEvent() {
      this.selectEventModel = {
        title: this.$t('asm_maintain_item_dialog.xuan_ze_shi_jian'),
        data: {
          productCode: this.form.productCode,
        },
      };
      this.selectEventVisible = true;
    },
    // 初始化
    initDialog: function () {
      this.form.serviceClass = this.type === 'maintain' ? this.serviceClassMap.upkeep : this.serviceClassMap.maintain;
      if (this.model.type === 'edit') {
        this.item = this.model.data;
        this.getItemDetail();
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
    },
    getItemDetail: function () {
      this.$getJSON(`${apis.BasicItemInfo}/${this.item.itemId}`).then((res) => {
        this.$setFormatData(this.form, res.data);
        this.form.serviceClass = this.type === 'maintain' ? this.serviceClassMap.upkeep : this.serviceClassMap.maintain;
        const attachList = res.data.attachList || [];
        const fileList = attachList.filter((item) => item.bizType === 'asm.service.item.icon');
        const textFileList = attachList.filter((item) => item.bizType === 'asm.service.item.atlas');
        this.fileList = fileList;
        this.textFileList = textFileList;
      });
    },
    // 确认保存
    async confirm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return;
        }
        if (this.type === 'maintain') {
          await Promise.all([this.$refs.maintainImage.submit(), this.$refs.maintainFile.submit()]);
        }

        if (this.model.type === 'add') {
          this.saveInsert();
        }
        if (this.model.type === 'edit') {
          this.saveUpdate();
        }
      });
    },
    // 保存新增
    saveInsert: function () {
      const attachList = [...this.textFileList, ...this.fileList];
      this.$postJSON(apis.BasicItemAdd, { ...this.form, attachList }).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    // 保存编辑
    saveUpdate: function () {
      const attachList = [...this.textFileList, ...this.fileList];
      this.$postJSON(apis.BasicItemUpdate, { ...this.form, attachList }).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success', this.form);
        this.closeDialog();
      });
    },
  },
};
</script>

<style lang="scss">
.maintain-item-dialog {
  .el-form-item {
    width: 100%;
  }

  .el-input-number--small {
    line-height: 30px;
  }

  .mce-edit-area {
    border-top: 0;
  }

  .mce-first {
    display: none;
  }
}
</style>
